export const vars = {
  timezones: [
    {
      "offset": "GMT-08:00",
      "name": "America/Los_Angeles",
      "alias": "Pacific"
    },
    {
      "offset": "GMT-07:00",
      "name": "America/Denver",
      "alias": "Mountain"
    },
    {
      "offset": "GMT-06:00",
      "name": "America/Chicago",
      "alias": "Central"
    },
    {
      "offset": "GMT-05:00",
      "name": "America/New_York",
      "alias": "Eastern"
    }
  ],
  timeInMilliseconds: {
    "day": 86400000,
    "week": 604800000,
    "year": 31556952000
  },
  countryCodes: [
    {
      "name": "USA",
      "code": "+1",
    }
  ],
  regexValidationPatterns: {
    phone: /^[^_]{12}$|^[^_]{14}$/,
    password: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,32}$/
  },
  supportedFormats: {
    imageTypes : ['image/png', 'image/jpg', 'image/jpeg','image/gif'],
    videoTypes: ['video/mp4'],
    audioTypes: ['audio/wav', 'audio/oog', 'audio/mp3']
  },
  rewardfulKey: "9bfaf4"
}